/** Obergrenze der Ziel-Marge (wie der Check in `company_settings.offer_target_margin_percent`). */
export const OFFER_TARGET_MARGIN_MAX_PERCENT = 95;

/** Gespeicherte Ziel-Marge lesen: Zahl 0–95, sonst `null` (keine Ziel-Hinweise). */
export function normalizeOfferTargetMarginPercent(raw: unknown): number | null {
  if (raw === null || raw === undefined || raw === '') return null;
  const n = typeof raw === 'number' ? raw : Number(raw);
  if (!Number.isFinite(n) || n < 0 || n > OFFER_TARGET_MARGIN_MAX_PERCENT) return null;
  return Math.round(n * 100) / 100;
}

/** Eingabe aus Einstellungen/API prüfen: `null`/leer oder Zahl 0–95 (auch „25,5“ oder „30 %“). */
export function parseOfferTargetMarginPercentInput(
  raw: unknown,
): { ok: true; value: number | null } | { ok: false } {
  if (raw === null || raw === undefined) return { ok: true, value: null };
  if (typeof raw === 'string') {
    const text = raw.trim().replace(/\s*%$/, '');
    if (!text) return { ok: true, value: null };
    if (!/^\d+([.,]\d+)?$/.test(text)) return { ok: false };
    return parseOfferTargetMarginPercentInput(Number(text.replace(',', '.')));
  }
  if (typeof raw !== 'number' || !Number.isFinite(raw)) return { ok: false };
  if (raw < 0 || raw > OFFER_TARGET_MARGIN_MAX_PERCENT) return { ok: false };
  return { ok: true, value: Math.round(raw * 100) / 100 };
}
